import qoalaStorage from '~/core/Storage';

export default {
  appLoader(state, data) {
    state.loader = data;
  },
  appMessage(state, data) {
    state.message = data;
  },
  appModalMessage(state, data) {
    state.modalMessage = data;
  },
  updateDataBank(state, value) {
    state.listBank = value;
    qoalaStorage.setItem('banks', JSON.stringify(state.listBank));
  },
  updatePin(state, value) {
    state.pin = value;
    qoalaStorage.setItem('pin', JSON.stringify(state.pin));
  },
  updateOTPStatus(state, value) {
    state.otpStatus = value;
    qoalaStorage.setItem('otpStatus', JSON.stringify(state.otpStatus));
  },
  updateProfileView(state, value) {
    state.profileView = value;
  },
  updateCalledOnce(state, value) {
    state.calledOnce = value;
  },
  updateFirstTime(state, value) {
    state.firstTime = value;
    qoalaStorage.setItem('activeFirstTime', JSON.stringify(state.firstTime));
  },
  updateNotifHome(state, value) {
    state.notifHome = value;
    qoalaStorage.setItem('notifHome', JSON.stringify(state.notifHome));
  },
  updatePdfLink(state, value) {
    state.pdfLink = value;
    qoalaStorage.setItem('pdfLink', state.pdfLink);
  },
  updateA2hs(state, value) {
    state.a2hs = value;
    qoalaStorage.setItem('A2HS', JSON.stringify(state.a2hs));
  },
  updateVolumeUp(state, value) {
    state.volumeUp = value;
  },
  updateVolumeDown(state, value) {
    state.volumeDown = value;
  },
  updateCountryCode(state, value) {
    state.countryCode = value;
    qoalaStorage.setItem('country', JSON.stringify(state.countryCode));
  },
  updateInfoDates(state, value) {
    state.pickUpDates = value;
  },
  updateAddressProvince(state, value) {
    state.addressData.province = value;
  },
  updateAddressCity(state, value) {
    state.addressData.city = value;
  },
  updateAddressDistrict(state, value) {
    state.addressData.district = value;
  },
  updateAddressVillage(state, value) {
    state.addressData.village = value;
  },
  updateLoginData(state, value) {
    state.loginData = value;
    qoalaStorage.setItem('loginData', JSON.stringify(state.loginData));
  },
  updateArticles(state, value) {
    state.articles = value;
  },
  updateDetailArticle(state, value) {
    state.detailArticle = value;
  },
  updatePromos(state, value) {
    console.log(value);
    state.promos = value;
  },
  updatePurchaseHistory(state, value) {
    let data = [];
    if (state.purchaseHistory) {
      if (typeof state.purchaseHistory === 'string') {
        data = JSON.parse(state.purchaseHistory);
        data.push(value);
      } else {
        data = state.purchaseHistory;
        data.push(value);
      }
    } else {
      data.push(value);
    }
    qoalaStorage.setItem('purchaseHistory', JSON.stringify(data));
    state.purchaseHistory = data;
  },
  deletePurchaseHistory(state) {
    let data = [];
    if (typeof state.purchaseHistory === 'string') {
      data = JSON.parse(state.purchaseHistory);
    } else {
      data = state.purchaseHistory || [];
    }
    data.pop();
    qoalaStorage.setItem('purchaseHistory', JSON.stringify(data));
  },
  removeHistory(state, value) {
    qoalaStorage.removeItem('purchaseHistory');
    state.purchaseHistory = value;
  },
  // updatePhoneBrand(state, value) {
  //   state.userPhone.phoneBrand = value;
  // },
  // updatePhoneModel(state, value) {
  //   state.userPhone.phoneModel = value;
  // },
  saveDetailPromo(state, value) {
    state.detailPromo = value;
  },
  saveDetailArticle(state, value) {
    state.detailArticle = value;
    qoalaStorage.setItem('detailArticle', JSON.stringify(value));
  },
  updateSearchPolis(state, payload) {
    const { type } = payload;
    type === 'update' ? (state.searchPolis = payload) : (state.searchPolis = null);
  },
  updateActiveTransaction(state, value) {
    state.activeTransaction = value;
    qoalaStorage.setItem('activeTransaction', JSON.stringify(value));
  },
  updateInsurancePartner(state, value) {
    state.insurancePartner = value;
  },
  updateComparedProduct(state, value) {
    state.comparedProduct = value;
    qoalaStorage.setItem('comparedProducts', JSON.stringify(state.comparedProduct));
  },
  removeComparedProduct(state) {
    qoalaStorage.removeItem('comparedProducts');
    state.comparedProduct = [];
  },
  updateGuest(state, value) {
    state.guest = value;
    qoalaStorage.setItem('guest', JSON.stringify(state.guest));
  },
  removeGuest(state) {
    qoalaStorage.removeItem('guest');
    state.guest = {};
  },
  updateTransactionHistory(state, value) {
    state.transactionHistory = value;
    qoalaStorage.setItem('transactionHistory', JSON.stringify(state.transactionHistory));
  },
  updateTransactionHistoryDetail(state, value) {
    state.transactionHistoryDetail = value;
    qoalaStorage.setItem('transactionHistoryDetail', JSON.stringify(state.transactionHistoryDetail));
  },
  updateSnapToken(state, value) {
    state.snapToken = value;
    qoalaStorage.setItem('snapToken', JSON.stringify(state.snapToken));
  },
  removeSnapToken(state) {
    state.snapToken = '';
    qoalaStorage.removeItem('snapToken');
  },
  updateLocaleLanguage(state, value) {
    state.localeLanguage = value;
    qoalaStorage.setItem('localeLanguage', JSON.stringify(state.localeLanguage));
  }
};
